export default function DemoModeBanner() {
  const enabled = typeof window !== 'undefined'
    && window.sessionStorage?.getItem('terminal_demo_mode') === 'true';

  if (!enabled) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="shrink-0 bg-violet-700 px-3 py-2 text-center text-[13px] font-bold text-white shadow-sm"
    >
      시연 모드 — 실제 결제가 발생하지 않습니다
    </div>
  );
}
